window.dashboardUser = null;

$(function(){

    addAuthTokenToRequest();

    const dashboardMobileSelector = $('#dashboardMobile');

    if(dashboardMobileSelector.length){

        if (dashboardMobileSelector.parent('.iti').length === 0) {

            dashboardMobileSelector.intlTelInput(defaultIntlTelInput);

        }

    }


    window.submitButton = $('#dashboardSignInButton');
    window.formResponse = $('#formResponse');

    $('#dashboardLogin').on('submit', function (e) {
        e.preventDefault();

        let formData = new FormData(this);
        formData.set('country_code', dashboardMobileSelector.intlTelInput("getSelectedCountryData").dialCode.replace('+', ''));

        const emailLoginInputs = $('#dashboardLoginWithEmail');

        submitButton.prop('disabled', true).text('wait...');
        formResponse.text('');


        if(emailLoginInputs.is(':visible')){

            dashboardLoginWithEmail(formData);

        }else{

            dashboardLoginWithMobile(formData);

        }

    });

    /*---------------------------- toggle login form ---------------------------------------*/

    const toggleLoginFormBtn = $('#toggleMobileEmailAuthForm');

    toggleLoginFormBtn.on('click', function (e) {
        e.preventDefault();
        formResponse.text('');

        const btn = $(this);
        let btnText = (btn.text().trim() !== 'Sign in using OTP') ? 'Sign in using OTP' : 'Sign in using Email';

        btn.text(btnText);

        const emailLoginInputs = $('#dashboardLoginWithEmail');
        const mobileLoginInputs = $('#dashboardLoginWithMobile');

        emailLoginInputs.find('input').prop('required', !emailLoginInputs.is(':visible'));
        $('#dashboardMobile').prop('required', !mobileLoginInputs.is(':visible'));

        emailLoginInputs.toggle();
        mobileLoginInputs.toggle();

        let submitBtnTxt = (emailLoginInputs.is(':visible')) ? 'Sign In' : 'Get OTP';
        submitButton.text(submitBtnTxt);


    });

    /*-----------------------------/toggle login form--------------------------------------*/

    $('#forgetPasswordForm').on('submit', function (e) {
        e.preventDefault();

        const form = $(this);
        const data = new FormData(this);
        const formResponse = $('#formResponse');
        const submitButton = form.find('button[type="submit"]');

        submitButton.prop('disabled', true).text('wait...');
        formResponse.text('');

        mainApiAxios.post('/dashboard/forget-password', data).then(res => {

            const responseData = res.data;

            formResponse.addClass('text-success').removeClass('text-danger').text(responseData.msg);
            window.location.href = `${APP_URL}/dashboard/reset-password?data_key=${responseData.data_key}&data_role=${responseData.data_role}`;

        }).catch(err => {

            const responseData = err.response.data;
            submitButton.prop('disabled', false).text('Send OTP');
            formResponse.addClass('text-danger').removeClass('text-success').text(responseData.msg);

        });

    });

    $('#resetPasswordForm').on('submit', function(e){
       e.preventDefault();

        const form = $(this);
        const data = new FormData(this);
        const formResponse = $('#formResponse');
        const submitButton = form.find('button[type="submit"]');
        const otpContainer = $('#otpContainer');
        const resetPasswordInputContainer = $('#resetPasswordInputContainer');

        submitButton.prop('disabled', true).text('wait...');

        if(otpContainer.is(':visible')){

            data.delete('password');
            data.delete('confirm_password');

            mainApiAxios.post('/dashboard/verify-email-otp', data).then(res => {
                const responseData = res.data;

                formResponse.removeClass('text-danger').addClass('text-success').text(responseData.msg);
                submitButton.prop('disabled', false).text('Reset Password');
                resetPasswordInputContainer.show();
                otpContainer.hide();

            }).catch(err => {

                const responseData = err.response.data;
                submitButton.prop('disabled', false).text('Verify OTP');
                formResponse.addClass('text-danger').removeClass('text-success').text(responseData.msg);

            })

        }else{

            data.delete('otp');

            if(data.get('password') !== data.get('confirm_password')){
                formResponse.addClass('text-danger').removeClass('text-success').text('Password Mismatched');
                submitButton.prop('disabled', false).text('Reset Password');
                return false;
            }

            mainApiAxios.post('/dashboard/reset-password', data).then(res => {

                const responseData = res.data;

                formResponse.removeClass('text-danger').addClass('text-success').text(responseData.msg);
                window.location.href = `${APP_URL}/dashboard/login`;

            }).catch(err => {

                const responseData = err.response.data;
                submitButton.prop('disabled', false).text('Reset Password');
                formResponse.addClass('text-danger').removeClass('text-success').text(responseData.msg);

            })

        }


    });


});

window.dashboardLoginSuccess = (response) => {

    if (!response) return;

    const responseData = response.data;

    dashboardUser = responseData.detail_log.user;
    localStorage.setItem('dashboardUser', JSON.stringify(dashboardUser));

    Cookies.set(
        'access_token_dashboard',
        responseData.jwt.access_token,
        { path: '/', domain: DOMAIN_NAME, expires: 7 }
    );

    addAuthTokenToRequest();
    dashboardLoginAction();
}

window.checkTokenExpired = (callback) => {

    addAuthTokenToRequest();

    mainApiAxios.get('/validate-token').then(res => {
        if (callback) callback(true);
    }).catch(err => {
        if (callback) callback(false);
    })
}

window.dashboardLoginAction = () => {
    window.location.href=`${APP_URL}/dashboard/index`;
}

window.addAuthTokenToRequest = () => {

    const accessToken = Cookies.get('access_token_dashboard') ?? '';
    mainApiAxios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

}

window.dashboardLogout = () => {

    mainApiAxios.post('/parent/logout').then(response => response.data)
        .then((response) => {
            if (response.code === 'OK') {
                console.log('logout successfully');
            }
        })
        .catch(err => {
            console.log(err)
        });

    window.dashboardUser = null;
    localStorage.removeItem('dashboardUser');
    Cookies.remove('access_token_dashboard', {domain: DOMAIN_NAME});
    window.location.href=`${APP_URL}/dashboard/login`;
}

window.dashboardLoginWithEmail = (data) => {

    mainApiAxios.post('/dashboard/email-login', data).then(res => {
        dashboardLoginSuccess(res);
    }).catch(err => {

        console.log(err);
        const responseData = err.response.data;
        formResponse.addClass('text-danger').removeClass('text-success').text(responseData.msg);
        submitButton.prop('disabled', false).text('Sign In');

    })

}

window.dashboardLoginWithMobile = (data) => {
    const otpContainer = $('#otpContainer');

    data.delete('name');
    data.delete('email');
    data.delete('password');

    if(otpContainer.is(':visible')){

        mainApiAxios.post('/verify-otp', data).then(res => {
            dashboardLoginSuccess(res);
        }).catch(err => {
            console.log(err);
            const responseData = err.response.data;
            formResponse.addClass('text-danger').removeClass('text-success').text(responseData.msg);
            submitButton.prop('disabled', false).text('Sign In');
        });


    }else{

        data.delete('otp');

        mainApiAxios.post('/request-otp', data).then(res => {

            const responseData = res.data;
            otpContainer.show();
            otpContainer.find('input').prop('required', true);
            submitButton.prop('disabled', false).text('Verify OTP');
            formResponse.removeClass('text-danger').addClass('text-success').text(responseData.msg);

        }).catch(err => {
            console.log(err);
            const responseData = err.response.data;
            formResponse.addClass('text-danger').removeClass('text-success').text(responseData.msg);
            submitButton.prop('disabled', false).text('Sign In');
        });

    }


}
